import { API } from 'utils/api';
import { formatDataResult } from 'utils/query';
import { formatPublishPayload } from './model';

//const { http } = API;
const baseUrl = '/api/leaderboard';

export const getLeaderboardById = async (eventId) => {
  const {data} = await API.GetInstance().http.get(`${baseUrl}/${eventId}`);
  return formatDataResult(data);
}

export const getLeaderboardDataById = async (eventId) => {
  let data;
  try {
    // Try with cookies (portalrankings)
    ({ data } = await API.GetInstance().http.get(`${baseUrl}/${eventId}/portalrankings`));
  } catch (err) {
    // If fails, fallback to rankings (without cookies)
    ({ data } = await API.GetInstance().http.get(`${baseUrl}/${eventId}/rankings`, { withCredentials: false }));
  }
  return {
    teams: data.map(formatDataResult),
  };
};

export const toggleLeaderboardPublishStatus = async (eventId, leaderboardId, unpublish) => {
  const payload = formatPublishPayload(eventId, !unpublish);
  const { data } = await API.GetInstance().http.patch(`${baseUrl}/${leaderboardId}`, payload);
  return formatDataResult(data);
};
